import { render, staticRenderFns } from "./ExpansionRowItemTabs.vue?vue&type=template&id=44fd1e94&lang=pug&"
import script from "./ExpansionRowItemTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExpansionRowItemTabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExpansionRowItemTabs.vue?vue&type=style&index=0&id=44fd1e94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports